
import DeleteIcon from "@material-ui/icons/Delete";
import moment from "moment";
import TableHeader from "../../0-ResuableComponents/tableComponents/TableHeader";

const headers = [
  { name: "Sub-Category", field: "name", sortable: true },
  { name: "ID", field: "id", sortable: false },
  { name: "Created By", field: "CreatedBy", sortable: false },
  { name: "Created At", field: "CreatedAt", sortable: false },
  { name: "Last Updated By", field: "LastUpdatedBy", sortable: false },
  { name: "Last Updated At", field: "LastUpdatedAt", sortable: false },
  { name: "Edit", field: "Edit", sortable: false },
  { name: "Delete", field: "Delete", sortable: false },
];

const CategorySubcategoriesTable = ({
  subCategoryList,
  setCurrentId,
  handleCategoryDelete,
  fetchAllSubcategories,
  setConfirmDialog,
  setSorting,
  handleShow,
}) => {
  
  return (
    <div className="col-lg-12 col-md-11">
      <div className="all-cate-tags">
        <div className="row justify- content-between">
          <div className="col-lg-12 col-md-12">
            <div className="card card-static-2 mb-30">
              <div className="card-title-2">
                <h4>Sub-Categories</h4>
              </div>
              <div className="card-body-table">
                <div className="table-responsive">
                  <table className="table ucp-table table-hover">
                    <TableHeader
                      headers={headers}
                      onSorting={(field, order) => setSorting({ field, order })}
                    />
                    <tbody>
                      {subCategoryList?.map((subCategory) => (
                        <tr key={subCategory.id}>
                          <td>{subCategory.name}</td>
                          <td>{subCategory.id}</td>
                          <td>
                            {moment(subCategory.metaInfo.created.at).format(
                              "lll"
                            )}
                          </td>
                          <td>{subCategory.metaInfo.created?.by?.name}</td>
                          <td>
                            {moment(subCategory.metaInfo.updated.at).format(
                              "lll"
                            )}
                          </td>
                          <td>{subCategory.metaInfo.updated?.by?.name}</td>
                          <td className="action-btns">
                            <i
                              className="fas fa-edit"
                              data-toggle="modal"
                              data-target="#exampleModal"
                              data-whatever="@mdo"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setCurrentId(subCategory._id);
                                handleShow();
                              }}
                            />
                          </td>
                          <td>
                            <DeleteIcon
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setConfirmDialog({
                                  isOpen: true,
                                  title: "Are you sure to delete this record?",
                                  subTitle: "You can't undo this operation",
                                  onConfirm: () => {
                                    handleCategoryDelete(subCategory._id);
                                  },
                                });
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategorySubcategoriesTable;
